import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { WATER_TEMPERATURE } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import MarkerLayer from './MarkerLayer'

class WaterTemperature extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const id = 'waterTemperatureLayerId'
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const rasterSource = {
      type: 'raster',
      tiles: [WATER_TEMPERATURE({ idToken, timeIso })],
      tileSize: 512
    }

    if (!visible) {
      return null
    }

    return [
      <Source
        key={'waterTemperatureSourceId'}
        id='waterTemperatureSourceId'
        tileJsonSource={rasterSource}
      />,
      <Layer
        key={'waterTemperatureLayerId'}
        type='raster'
        id='waterTemperatureLayerId'
        sourceId='waterTemperatureSourceId'
        layout={{
          visibility: visible ? 'visible' : 'none'
          // 'raster-fade-duration': 300
        }}
        paint={paint}
        />,
      <MarkerLayer id={'WaterTemperature'} key='MarkerLayer' />
    ]
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, 'WaterTemperature'),
      paint: getPaint(state, 'WaterTemperature'),
      time: state.layer.times.WaterTemperature || undefined
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps(), null)(WaterTemperature)



// WEBPACK FOOTER //
// ./src/layers/WaterTemperature.js